import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPriorityCritical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M18.5303 10.2197C18.8232 10.5126 18.8232 10.9874 18.5303 11.2803C18.2374 11.5732 17.7626 11.5732 17.4697 11.2803L12 5.81066L6.53033 11.2803C6.23744 11.5732 5.76256 11.5732 5.46967 11.2803C5.17678 10.9874 5.17678 10.5126 5.46967 10.2197L11.4697 4.21967C11.7626 3.92678 12.2374 3.92678 12.5303 4.21967L18.5303 10.2197Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.5303 18.2197C18.8232 18.5126 18.8232 18.9874 18.5303 19.2803C18.2374 19.5732 17.7626 19.5732 17.4697 19.2803L12 13.8107L6.53033 19.2803C6.23744 19.5732 5.76256 19.5732 5.46967 19.2803C5.17678 18.9874 5.17678 18.5126 5.46967 18.2197L11.4697 12.2197C11.7626 11.9268 12.2374 11.9268 12.5303 12.2197L18.5303 18.2197Z",
		fill: "currentColor"
	})]
});
export { SvgIconPriorityCritical as ReactComponent };
